/**
 * https://confluence.tde.sktelecom.com/pages/viewpage.action?pageId=394988618
 */

type LowercaseCookieKeys =
  | 'apollo-os'
  | 'apollo-os-version'
  | 'apollo-app-version'
  | 'apollo-phone-model-name'
  | 'apollo-carrier-name'
  | 'apollo-skt'
  | 'apollo-authorization'

type FormattedCookieKeys =
  | 'os'
  | 'osVersion'
  | 'appVersion'
  | 'phoneModelName'
  | 'authorization'
  | 'carrier'
  | 'apolloSkt'

const FORMATTED_COOKIE_KEYS: Record<LowercaseCookieKeys, FormattedCookieKeys> = {
  'apollo-os-version': 'osVersion',
  'apollo-os': 'os',
  'apollo-app-version': 'appVersion',
  'apollo-phone-model-name': 'phoneModelName',
  'apollo-authorization': 'authorization',
  'apollo-carrier-name': 'carrier', // APOLLOTF-272: "Apollo-Carrier-Name" to "통신사 or 빈값"
  'apollo-skt': 'apolloSkt' // AIPHONE-2480
}

type ValueOf<T> = T[keyof T]
type AuthCookie = { [key in ValueOf<typeof FORMATTED_COOKIE_KEYS>]: string }

export const useAuthCookie = () => {
  const cookies = window.document.cookie.split(';')
  const result: AuthCookie = cookies.reduce((prev, next) => {
    const keyValue = next.split('=')
    const key = keyValue[0].trim().toLowerCase() as keyof typeof FORMATTED_COOKIE_KEYS
    const value = keyValue[1] as string
    prev[FORMATTED_COOKIE_KEYS[key]] = value
    return prev
  }, {} as AuthCookie)

  return result
}

type MyPlanCookie = {
  aiCallUserId: string
  adotUserId: string
  tphoneUserId?: string
  briefingUserId: string
  authToken?: string
  aicallActiveToken?: string
}

export const useMyPlanCookie = () => {
  const cookies = window.document.cookie.split(';')
  const result: MyPlanCookie = {
    aiCallUserId: '',
    adotUserId: '',
    tphoneUserId: '',
    briefingUserId: '',
    authToken: '',
    aicallActiveToken: ''
  }
  cookies.forEach((cookie) => {
    const [name, value] = cookie.split('=')
    const trimmedName = name.trim()
    if (trimmedName in result) {
      result[trimmedName as keyof MyPlanCookie] = value
    }
  })

  return result
}
